export default "__VITE_ASSET__CMvNfwX2__"